import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import CurrencyConverter from "../../Currency/CurrencyConverter";
import { ApiHook } from "../../hooks/apiHook";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import { ProgressBar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const GlobalRally = ({ earnings, currency, conversionFactor }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("currentYear");
  const moduleStatus = useSelector(
    (state) => state.dashboard?.appLayout?.moduleStatus
  );

  const navigate = useNavigate();
   const handleExpand = () => {
   navigate('/global-rally');
  };

  // Get current and previous year dynamically
  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;

  // Dynamic variables from earnings data
  const currentYearData = earnings?.rallyLevels?.currentYear || {};
  const rallyConfig = earnings?.Configuration || {};
  
  
  // Current year metrics
  const totalKC = parseFloat(earnings?.currentYearData?.totalKC || 0);
  const newKC = parseFloat(earnings?.currentYearData?.new_kc || 0);
  const qualificationStatus = currentYearData?.qualificationStatus || 'Not Qualified';
  const targetTotalKC = earnings?.rallyLevel?.nextLevel?.cc || 2500;
  const targetNewKC = rallyConfig?.min_new_cc || 500;

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div className={"col-md-6"}>
      <div className="joinings_viewBox teamperfomance">
        <div className="joinings_viewBox_head">
          <h5>{t("globalRally")}</h5>
              <p style={{ textAlign: "right" }}>  <a className="btn btn-tree-act" onClick={handleExpand}>
                <i className="fa fa-expand"></i>
              </a></p>
        </div>
        {earnings && (
          <ul
            className="teamPerfomance_tab nav nav-tabs mb-3"
            id="ex1"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <Link
                className={`nav-link active`}
                id={`ex1-tab-${"currentYear"}`}
                data-bs-toggle="tab"
                role="tab"
                aria-controls={"currentYear"}
                aria-selected={true}
                onClick={() => handleTabClick("currentYear")}
              >
                {currentYear}
              </Link>
            </li>
          </ul>
        )}

        <div className="tab-content" id="ex2-content">
          <div
            className="tab-pane show active"
            id={"currentYear"}
            role="tabpanel"
            aria-labelledby={"currentYear"}
          >
            <div className="teammbrs_cnt">
              {!earnings ? (
                <div className="teammbrs_cnt_name_dtl">
                  <div className="teammbrs_cnt_name">
                    <Skeleton count={9} />
                  </div>
                </div>
              ) : earnings?.length === 0 ? (
                <div className="no-data-div">
                  <div className="no-data-div-image">
                    <img src="/images/nodata-image.png" alt="" />
                  </div>
                  <p>{t("noDataFound")}</p>
                </div>
              ) : (
                <>
                  <div
                    className="row forever_table"
                    style={{
                      padding: "15px",
                      justifyItems: "center",
                      width: "100%",
                    }}
                  >
                    <table className="table">
                      <tbody>
                        <tr>
                          <th>{t("Total KC")}</th>
                          <td>{t("You have")} {totalKC.toFixed(3)} {t("KC")}</td>
                          <td>
                            <ProgressBar 
                              now={totalKC} 
                              label={`${totalKC.toFixed(3)} / ${targetTotalKC}`} 
                              variant="success" 
                              max={targetTotalKC}
                              style={{ minHeight: '25px', fontSize: '12px' }}
                            />
                            {targetTotalKC} {t("Required")}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("New KC")}</th>
                          <td>{t("You have")} {newKC.toFixed(3)} {t("KC")}</td>
                          <td>
                            <ProgressBar 
                              now={newKC} 
                              label={`${newKC.toFixed(3)} / ${targetNewKC}`} 
                              variant="success" 
                              max={targetNewKC}
                              style={{ minHeight: '25px', fontSize: '12px' }}
                            />
                            {targetNewKC} {t("Required")}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Level Status")}</th>
                          <td>{earnings?.rallyLevel?.id  ?  t("Qualified") : t("Not Qualified")}</td>
                          <td>{earnings?.rallyLevel?.name}</td>
                        </tr>
                        <tr>
                          <th>{t("KC Needed")}</th>
                          <td>{Math.max(0, targetTotalKC - totalKC).toFixed(3)} {t("KC")}</td>
                          <td>{t("Remaining for next level")}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalRally;
